module.exports = __webpack_public_path__ + "static/media/triad.9ec609ed.png";